import React from "react";

const statusColors = {
  // Order statuses - unified
  PENDING: "bg-gray-100 text-gray-700",
  CONFIRMED: "bg-[#FFE8C8] text-[#C45500]",
  PROCESSING: "bg-[#FFE8C8] text-[#C45500]",
  PACKED: "bg-[#FFE8C8] text-[#C45500]",
  READY_TO_SHIP: "bg-[#FFE8C8] text-[#C45500]",
  SHIPPED: "bg-green-100 text-green-700",
  IN_TRANSIT: "bg-teal-100 text-teal-700",
  OUT_FOR_DELIVERY: "bg-teal-100 text-teal-700",
  DELIVERED: "bg-green-100 text-green-800",
  CANCELLED: "bg-red-100 text-red-700",
  CANCELED: "bg-red-100 text-red-700",
  RETURN_REQUESTED: "bg-orange-100 text-orange-700",
  RETURNED: "bg-orange-100 text-orange-700",
  REFUNDED: "bg-red-100 text-red-600",
  // Amazon-specific
  UNSHIPPED: "bg-yellow-100 text-yellow-700",
  PARTIALLY_SHIPPED: "bg-[#FFE8C8] text-[#C45500]",
  INVOICE_UNCONFIRMED: "bg-orange-100 text-orange-700",
  UNFULFILLABLE: "bg-red-100 text-red-700",
  // Payment statuses
  PAID: "bg-green-100 text-green-700",
  UNPAID: "bg-red-100 text-red-700",
  PARTIALLY_PAID: "bg-yellow-100 text-yellow-700",
  COD_PENDING: "bg-yellow-100 text-yellow-700",
  // Fulfillment statuses
  UNFULFILLED: "bg-gray-100 text-gray-700",
  PARTIALLY_FULFILLED: "bg-yellow-100 text-yellow-700",
  FULFILLED: "bg-green-100 text-green-700",
  // Sync statuses
  IN_PROGRESS: "bg-[#FFE8C8] text-[#C45500]",
  COMPLETED: "bg-green-100 text-green-700",
  FAILED: "bg-red-100 text-red-700",
  // Generic
  ACTIVE: "bg-green-100 text-green-700",
  INACTIVE: "bg-gray-100 text-gray-700",
  UNKNOWN: "bg-gray-100 text-gray-500",
};

export default function StatusBadge({ status, className = "" }) {
  if (!status) return null;
  const colorClass = statusColors[status] || "bg-gray-100 text-gray-700";
  const displayText = status.replace(/_/g, " ");

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}>
      {displayText}
    </span>
  );
}
